// router.js
import { createRouter, createWebHistory } from 'vue-router';
 
 
// 创建router实例
const router = createRouter({
  history: createWebHistory(),
  routes:[
    { path: '/h5/689',name:"689_h5_paypal",meta:{title:"Bingo Royal"}, component: ()=>{return import("@/view/689paypalPage.vue")} },
    { path: '/h5/9021',name:"9021_h5_paypal",meta:{title:"Solitaire Duels"}, component: ()=>{return import("@/view/9021paypalPage.vue")} },
    { path: '/h5/9026',name:"9026_h5_paypal",meta:{title:"Bubble Fever"}, component: ()=>{return import("@/view/9026paypalPage.vue")} },
    { path: '/h5/9023',name:"9023_h5_paypal",meta:{title:"Fortune Slot"}, component: ()=>{return import("@/view/9023paypalPage.vue")} },
  ]
});
router.beforeEach((to) => {
  document.title = to?.meta.title;
});
export default router;